// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ulv-","clinicsSelect":"styles_clinicsSelect__ugoCN"};